import {Button} from './Button';
import {PageHeader, Text} from './Text';

export function NotFound({type = 'page'}: {type?: string}) {
  const heading = `We’ve lost this ${type}`;
  const description = `We couldn’t find the ${type} you’re looking for. Try checking the URL or heading back to the home page.`;
  const image =
    'https://res.cloudinary.com/oves/image/upload/s--rGhh7AU4--/c_crop,h_3600,w_8640,y_200/v1654254356/promo_AT/glowing_battery.jpg';
  return (
    <>
      <div className="shop-details-area ptb-80">
        <div className="container">
          <div className="row">
            <div className="error-area">
              <div className="d-table">
                <div className="d-table-cell">
                  <div className="container">
                    <div className="error-content">
                      <div className="notfound-404">
                        <h1>Oops!</h1>
                      </div>
                      <h3>{heading}</h3>
                      <Text width="narrow" as="p">
                        {description}
                      </Text>

                      <Button width="auto" className="btn btn-primary" to={'/'}>
                        Go to Homepage
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
